import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/Layout';
import PatientList from '../components/patients/PatientList';
import FilterPanel from '../components/patients/FilterPanel';
import PaginationControls from '../components/patients/PaginationControls';
import { usePatients } from '../hooks/usePatients';

const PatientsPage = () => {
  const { patients, loadPatients, loading, filters } = usePatients();
  const [currentPage, setCurrentPage] = useState(1);
  const [patientsPerPage] = useState(12);
  
  useEffect(() => {
    loadPatients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // Filter patients based on search term and payment status
  const filteredPatients = patients.filter(patient => {
    // Search term filter
    if (filters.searchTerm) {
      const searchTerm = filters.searchTerm.toLowerCase();
      // Search in patient name
      const patientName = patient.profile?.name?.toLowerCase() || '';
      // Search in patient ID
      const patientId = patient.sukra_id?.toLowerCase() || '';
      // Search in order ID
      const orderId = patient.sukra_order_id?.toLowerCase() || '';
      // Search in branch name
      const branchName = patient.facility?.branch_name?.toLowerCase() || '';
      
      const matchesSearch = patientName.includes(searchTerm) || 
             patientId.includes(searchTerm) || 
             orderId.includes(searchTerm) ||
             branchName.includes(searchTerm);
      
      if (!matchesSearch) return false;
    }
    
    // Payment status filter
    if (filters.paymentStatus) {
      const paymentId = patient.payment_id;
      
      if (filters.paymentStatus === 'paid') {
        return paymentId && paymentId.trim() !== '';
      } else if (filters.paymentStatus === 'pending') {
        return !paymentId || paymentId.trim() === '' || paymentId === null || paymentId === undefined;
      }
    }
    
    return true;
  });
  
  // Get current patients for pagination
  const indexOfLastPatient = currentPage * patientsPerPage;
  const indexOfFirstPatient = indexOfLastPatient - patientsPerPage;
  const currentPatients = filteredPatients.slice(indexOfFirstPatient, indexOfLastPatient);
  const totalPages = Math.ceil(filteredPatients.length / patientsPerPage);
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Layout>
      {/* <div className="mb-3">
        <h1 className="text-2xl font-bold">Patients</h1>
      </div> */}
      
      <FilterPanel filteredCount={filteredPatients.length} />
      
      <PatientList 
        patients={currentPatients} 
        loading={loading} 
      />
      
      {totalPages > 1 && (
        <PaginationControls 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Layout>
  );
};

export default PatientsPage;